module.exports = __webpack_public_path__ + "media/components/Builder/Library/Images/ChevronBlackRight-e6ed5e414364114386b62cade928f69f.png";